export default __webpack_public_path__ + "static/media/SPOORTHI_MUDNOOR_SICENCE.e0610dfb.JPG";